import {
  ButtonBase,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import React from 'react'

import { persianRegex } from '../../helpers/regex'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { TemplateBrief } from '../../types/contractTemplate'
import useStyles from './styles/TemplatesTable.styles'

interface ContractRowProps {
  data: TemplateBrief
  providerCode: string
}

const ContractRow: React.FC<ContractRowProps> = ({ data, providerCode }) => {
  const theme = useTheme()
  const { Title, Id } = data
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const classes = useStyles()

  const isPersian = persianRegex.test(Title)

  return (
    <ButtonBase
      className={[
        classes.tableRow,
        isSmallScreen ? classes.tableRowSkeletonForMobile : ''
      ].join(' ')}
      component={LocalizedLink}
      to={`/templates/provider/${providerCode}/template/${Id}`}>
      <div className={classes.nameCell}>
        <Typography
          variant="h4"
          style={isPersian ? { fontFamily: 'IranSans' } : undefined}>
          {Title}
        </Typography>
      </div>
      {!isSmallScreen && (
        <div className={classes.editButtonContainer}>
          <Typography variant="body1">
            <EditIcon />
          </Typography>
        </div>
      )}
      {isSmallScreen && (
        <div className={classes.editButtonContainer}>
          <Typography variant="body1">
            <EditIcon className={classes.EditIcon} />
          </Typography>
        </div>
      )}
    </ButtonBase>
  )
}

export default ContractRow
